var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-title',[_vm._v(_vm._s(_vm.$t('invoices.page_title')))]),_c('users-table',{ref:"table",attrs:{"itemid":_vm.itemId,"itemtype":_vm.itemType},on:{"company-filter":function($event){_vm.companyFilter = $event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }